import { z } from "zod";

/**
 * L'import de l'ancien Castellan (lot Q1, tache E.5) : le fichier que `scripts/export-ancien.mjs` produit
 * sur le PC de Nicolas, et le corps de `POST /api/direct/import`. Q6 (les des) ajoutera une `version: 2` :
 * rien d'autre n'entre dans ce fichier en Q1.
 */

/** Ce que le corps pese au plus : sous les 2 Mo du nginx du frontal (`client_max_body_size 2m`). */
export const IMPORT_OCTETS_MAX = 2_000_000;

/** Au plus `max` points de code : le script coupe ainsi, et `.max()` de zod compte des unites UTF-16 (un emoji en vaut deux). */
const bornee = (max: number) =>
  z.string().refine((valeur) => Array.from(valeur).length <= max, `Au plus ${max} caracteres`);

export const importViewerSchema = z.object({
  twitchUserId: z.string().regex(/^\d{1,20}$/),
  login: bornee(64),
  nom: bornee(64),
  premiereVenue: z.string().nullable(),
  /** Le dernier `joinedAt` de l'ancienne base. Facultatif : un fichier plus ancien n'en a pas. */
  derniereVenue: z.string().nullable().optional(),
  streams: z.number().int().min(0),
  messages: z.number().int().min(0),
  bits: z.number().int().min(0),
  messagesTexte: z.array(z.object({ texte: bornee(500), envoyeLe: z.string() })).max(5_000),
});

export const importAncienSchema = z.object({
  version: z.literal(1),
  viewers: z.array(importViewerSchema).max(5_000),
});
export type ImportAncien = z.infer<typeof importAncienSchema>;

/** `POST /api/direct/import` : `ignores` = oppositions et bots ; `messages` = ceux qui viennent d'etre ecrits. */
export const reponseImportSchema = z.object({
  importes: z.number().int(),
  ignores: z.number().int(),
  messages: z.number().int(),
});
export type ReponseImport = z.infer<typeof reponseImportSchema>;
